import { lazy } from 'react';

export const AccountsManageProfileScreenLazy = lazy(async () => {
  const { AccountsManageProfileScreen } = await import('./accounts-manage-profile.screen');
  return { default: AccountsManageProfileScreen };
});
